<template>
  <v-list-item
    @click="viewDeviceOnMap"
    link
    :disabled="!hasPermissions"
    prepend-icon="mdi-map-marker"
  >
    <v-list-item-title data-cy="deviceViewOnMap">
      {{ $t('manageDevices.actions.viewOnMap') }}
    </v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { isNavigationFailure } from 'vue-router'
import { DeviceType } from '@/api/services/utils'
import { Access } from '@/services/device-access'
import { getPermissionsByDeviceId } from '@/services/subscriptions'
import { SlugsEnum } from '@/permissions/SlugsEnum'
import { getUserAccountId } from '@/helpers/loginas/logInAsHelper'
import { NAMESPACES } from '@/store/types'
import { DEVICE_GETTERS } from '@/store/devices'
import { MAP_ACTIONS } from '@/store/map'

export default defineComponent({
  props: {
    deviceId: {
      type: String,
      default: ''
    },
    accessLevel: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      accountId: null as string | null
    }
  },
  computed: {
    deviceType(): DeviceType {
      if (this.accessLevel === Access.FULL) {
        return this.$api.deviceType.USER
      }
      if (this.accessLevel === Access.SHARED) {
        return this.$api.deviceType.SHARED
      }
      return this.$api.deviceType.PUBLIC
    },
    isMine(): boolean {
      return (
        this.accountId ===
        this.$store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_ACCOUNT_BY_DEVICE_ID}`](
          this.deviceId
        )
      )
    },
    serial(): string {
      return this.$store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_SERIAL_BY_DEVICE_ID}`](
        this.deviceId
      )
    },
    hasPermissions(): boolean {
      if (!this.isMine) {
        return true
      }
      const deviceSlugPermissions = getPermissionsByDeviceId(this.deviceId)
      return deviceSlugPermissions?.includes(SlugsEnum.MapViewPin) ?? false
    }
  },
  async mounted() {
    this.accountId = await getUserAccountId(this.$auth)
  },
  methods: {
    viewDeviceOnMap(): void {
      const device = {
        deviceId: this.deviceId,
        deviceType: this.deviceType
      }
      this.$store.dispatch(`${NAMESPACES.MAP}/${MAP_ACTIONS.START_DEVICE_VIEW_MODE}`, device)
      this.$router.push('/home').catch((err: unknown) => {
        if (isNavigationFailure(err)) {
          return err
        }
        return Promise.reject(err)
      })
    }
  }
})
</script>
